// Client API formation certifiante — endpoint /api/v1/formation/* (backend core).
// Generalise par parcours (AVOCAT / ARBITRE) via le query param `parcours`.
import { apiClient } from "@/lib/api";

export type Parcours = "AVOCAT" | "ARBITRE";

export interface FormationCertification {
  parcours: string;
  certifie: boolean;
  statut: string;
  badge: string | null;
  date_renouvellement: string | null;
}

export interface ModuleEtat {
  module_id: string;
  valide: boolean;
  score: number | null;
}

export interface FormationProgression {
  parcours: string;
  modules: ModuleEtat[];
  statut_certification: string;
  badge_code: string | null;
  date_certification: string | null;
}

function pq(parcours: Parcours): string {
  return `?parcours=${parcours}`;
}

export async function getFormationCertification(
  parcours: Parcours = "AVOCAT",
): Promise<FormationCertification> {
  const { data } = await apiClient.get<FormationCertification>(
    `/api/v1/formation/certification${pq(parcours)}`,
  );
  return data;
}

export async function getFormationProgression(
  parcours: Parcours = "AVOCAT",
): Promise<FormationProgression> {
  const { data } = await apiClient.get<FormationProgression>(
    `/api/v1/formation/progression${pq(parcours)}`,
  );
  return data;
}

export async function validerModule(
  moduleId: string,
  score?: number,
  parcours: Parcours = "AVOCAT",
): Promise<FormationProgression> {
  const { data } = await apiClient.post<FormationProgression>(
    `/api/v1/formation/valider-module/${moduleId}${pq(parcours)}`,
    score === undefined ? {} : { score },
  );
  return data;
}
